import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './Sidebar.module.css';

interface SidebarProps {
  mobile?: boolean;
}

const navItems = [
  { id: 'home', label: 'Início', icon: '🏠' },
  { id: 'reports', label: 'Relatórios', icon: '📊' },
  { id: 'users', label: 'Usuários', icon: '👥' },
  { id: 'settings', label: 'Configurações', icon: '⚙️' },
];

const Sidebar: React.FC<SidebarProps> = () => {
  const [expanded, setExpanded] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const userJson = localStorage.getItem('auth:user');
  const user = userJson ? (JSON.parse(userJson) as { email: string }) : null;
  const toggleExpand = () => setExpanded((e) => !e);
  const toggleMobile = () => setMobileOpen((o) => !o);

  const handleLogout = () => {
    localStorage.removeItem('auth:user');
    void navigate('/', { replace: true });
  };

  useEffect(() => {
    const l = (e: KeyboardEvent) => {
      if (e.key === 'b' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggleExpand();
      }
      if (e.key === 'Escape' && mobileOpen) setMobileOpen(false);
    };
    window.addEventListener('keydown', l);
    return () => window.removeEventListener('keydown', l);
  }, [mobileOpen]);

  const initials = user?.email ? user.email.slice(0, 2).toUpperCase() : 'US';

  return (
    <>
      {mobileOpen && (
        <div
          className={styles.backdrop}
          role="button"
          tabIndex={0}
          aria-label="Fechar menu"
          onClick={() => setMobileOpen(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setMobileOpen(false);
          }}
        />
      )}
      <aside
        className={`${styles.sidebar} ${expanded ? styles.expanded : styles.compact} ${mobileOpen ? 'visible' : ''}`}
      >
        <div className={styles.header}>
          <div className={styles.logoCircle}>DB</div>
          <span style={{ display: expanded ? 'inline' : 'none' }}>Dashboard</span>
          <button
            aria-label={expanded ? 'Compactar' : 'Expandir'}
            className={styles.toggleBtn}
            type="button"
            onClick={toggleExpand}
          >
            {expanded ? '«' : '»'}
          </button>
        </div>
        <nav className={styles.nav}>
          <div className={styles.navGroupTitle}>Menu</div>
          {navItems.map((item) => (
            <button key={item.id} className={styles.itemBtn} type="button">
              <span className={styles.iconBox}>{item.icon}</span>
              <span className={styles.label}>{item.label}</span>
            </button>
          ))}
        </nav>
        <div className={styles.footer}>
          <div className={styles.userBox}>
            <div className={styles.userInitials}>{initials}</div>
            <div className={styles.userEmail}>{user?.email || 'usuario@mock'}</div>
          </div>
          <button onClick={handleLogout} className={styles.logoutBtn}>
            <span>⏻</span>
            <span className={styles.label}>Sair</span>
          </button>
        </div>
      </aside>
      {/* Botão flutuante mobile */}
      <button
        type="button"
        onClick={toggleMobile}
        style={{
          position: 'fixed',
          top: '1rem',
          left: '1rem',
          zIndex: 70,
          background: '#1d3557',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: 48,
          height: 48,
          fontSize: '1.25rem',
          display: 'none',
        }}
      >
        ☰
      </button>
      <style>{`@media (max-width:860px){ button[style]{ display:flex; align-items:center; justify-content:center;} }`}</style>
    </>
  );
};

export default Sidebar;
